/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import chica from '../../../Recursos/chica_home.png'
import carpeta from '../../../Recursos/carpeta.png'
import personas from '../../../Recursos/personas.png'
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Home_Portada from "../../Formularios/Formulario_Home_Portada";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Informacion from "../../Dialogos/Dialogo_Informacion";

const Home_Portada = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Informacion, titulo: 'Dejanos Contactarte'})
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})

    const abrirFormulario = async () => {

        let entidad = await obtenerEntidad();
        abrir(entidad)

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <img src={chica} alt="chica" width={sCell ? '100%' : '90%'} height={'auto'}
                         style={{borderRadius: 20}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: sCell ? 32 : 54,
                                fontWeight: sCell ? 800 : 600,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                ¿Tienes un sueño? Te ayudamos a cumplirlo
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography
                                sx={{fontSize: sCell ? 16 : 20, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                                Esperanza hispana transforma tu esfuerzo en progreso y haz realidad el futuro que
                                imaginas
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography sx={{fontSize: 14, fontWeight: 400, px: 0, color: '#00000080'}}>
                                Déjanos contactarte
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Formulario_Home_Portada props={props} click={abrirFormulario}/>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end', mt: 0}}>
                    <img src={carpeta} width={'100%'} height={'auto'}/>
                    {!sCell &&
                        <img src={personas} width={'80%'} height={'auto'}/>
                    }
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Portada